import { render } from "./DummyTable.vue?vue&type=template&id=424ee3ee&scoped=true"
import script from "./DummyTable.vue?vue&type=script&lang=js"
export * from "./DummyTable.vue?vue&type=script&lang=js"

import "./DummyTable.vue?vue&type=style&index=0&id=424ee3ee&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-424ee3ee"

export default script